//TODO: Déplacer les routeurs dans le dossier src/component/router
import * as React from "react";
import {Route, Switch} from "react-router-dom";
import * as routes from "../../util/routes";
import Dashboard from "../../component/dashboard";
import LocalAuthorities from "./local-authorities";
import * as Router from "../../component/router";
import Instructions from "../../component/instructions";
import Aide from "../../component/aide";
import Scenarii from "../../component/scenarii";
import PPI from "./ppi";
import Projection from "./projection";
import Retrospective from "./retrospective";
import Users from "../../component/users";
import Regions from "../../component/regions";
import Header from "../../component/header";
import Menu from "../../component/menu";
import Content from "../../component/content";
import Iframe from "./iframe";
import * as Model from "../../model";
import {
    getBudgetAnnexeData,
    findCurrentValidatedScenario,
} from "../../service/sfp/scenarii-service";
import {KEY_CURRENT_LOCAL_AUTHORITY} from "../../util/storage"
import GlossaryComponent from "../../component/glossary/glossary-component";
import RegulatoryInformationComponent from "../../component/regulatory-information/regulatory-information";

export default class SecuredComponent extends React.Component<SecuredComponentProps> {
    componentDidMount() {
        window.addEventListener("beforeunload", this._handleRefresh);

        if (this.props.currentLocalAuthority !== null) {
            findCurrentValidatedScenario(this.props.currentLocalAuthority).then((s) =>
                this.tableData(s)
            );
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.currentLocalAuthority !== null &&
            this.props.currentLocalAuthority !== prevProps.currentLocalAuthority
        ) {
            findCurrentValidatedScenario(this.props.currentLocalAuthority).then((s) =>
                this.tableData(s)
            );
        }
    }

    componentWillUnmount() {
        window.addEventListener("beforeunload", this._handleRefresh);
    }    
    

    tableData = async (scenario) => {
        this.props.setTotalCalls(0); // Réinitialise le nombre total d'appels
        this.props.allCallsFinished(false); // Réinitialise l'état de fin d'appels
        this.props.resetOngoingCalls();

        let fetchedTableData: any = [];
        window.localStorage.setItem("fetchedTableData", "calculating");
        
        if (
            this.props.currentLocalAuthority !== null &&
            scenario !== null &&
            scenario
        ) {
            if (
                this.props.currentLocalAuthority.members &&
                this.props.currentLocalAuthority.members.length
            ) {
                let count = 0;
                this.props.setTotalCalls(this.props.currentLocalAuthority.members.length);

                for (
                    let i = 0;
                    i < this.props.currentLocalAuthority.members.length;
                    i++
                ) {
                    this.props.incrementCall();

                    let laData = this.props.currentLocalAuthority.members;
                    let responseData = await getBudgetAnnexeData(
                        laData[i].id + "",
                        scenario.id + ""
                    );
                    fetchedTableData.push({
                        data: responseData,
                        code: laData[i].code,
                        name: laData[i].name,
                    });
                    count++;
                }

                await getBudgetAnnexeData(
                    this.props.currentLocalAuthority.id + "",
                    scenario.id + ""
                ).then((response) => {
                    fetchedTableData.push({
                        data: response,
                        code: this.props.currentLocalAuthority.code,
                        name: this.props.currentLocalAuthority.name,
                        isParent: true,
                    });
                });
                this.props.finishCall();
            }
        }
        this.props.fetchedTableDataValue(fetchedTableData);
        this.props.allCallsFinished(true);
        // window.localStorage.setItem('fetchedTableData', JSON.stringify(fetchedTableData));
    };
    

    /* Loader on ReportPage */

    // incrementLoader(){
    // 	let intervalIncrement = setInterval(()=>{ if(this.props.loaderStoreData >= 80){
    // 		clearInterval(intervalIncrement);
    // 		return
    // 	}
    // 	this.props.setLoaderValue(this.props.loaderStoreData+1) }, 1000);
    // }

    /* calculating fetchedTableData when LA is selected */

    render() {
        return (
            <div id="secured" className={this.props.menuOpen ? "navigable" : ""}>
                <Header
                    menuOpen={this.props.menuOpen}
                    menuButtonActive={this.props.menuOpen}
                    onMenuButtonClick={this.props.onMenuButtonClick}
                    title={this.props.title}/>

                <Menu
                    currentLocalAuthority={this.props.currentLocalAuthority}
                    currentUser={this.props.currentUser}
                    loadingCurrentLocalAuthority={this.props.loadingCurrentLocalAuthority}
                    loadingCurrentUser={this.props.loadingCurrentUser}
                    loadingLocalAuthorities={this.props.loadingLocalAuthorities}
                    localAuthorities={this.props.localAuthorities}
                    open={this.props.menuOpen}
                    loans={this.props.loans}
                    onLocalAuthorityChange={(id) => this.props.onLocalAuthorityChange(id)}
                    onLogout={() => this.props.onLogout()}
                    onMenuItemClick={() => this.props.onMenuItemClick()}
                />

                {this.props.currentUser && (
                    <Content>
                        <Switch>
                            <Route exact path={routes.ROOT} component={Dashboard}/>
                            {/* <Route path={routes.LOGIN} component={Iframe}/> */}
                            <Route path={routes.USERS} component={Users}/>
                            <Route path={routes.REGIONS} component={Regions}/>
                            <Route
                                path={routes.LOCAL_AUTHORITIES}
                                component={LocalAuthorities}
                            />
                            <Route path={routes.INSTRUCTIONS} component={Instructions}/>
                            <Route path={routes.PPI} component={PPI}/>
                            <Route path={routes.AIDE} component={Aide}/>
                            <Route
                                path={routes.LOCAL_AUTHORITY_PATTERN + routes.RETROSPECTIVE}
                                component={Retrospective}
                            />
                            <Route
                                path={routes.LOCAL_AUTHORITY_PATTERN + routes.PPI}
                                component={PPI}
                            />
                            <Route
                                path={
                                    routes.LOCAL_AUTHORITY_PATTERN + routes.PROJECTION_SCENARII
                                }
                                component={Scenarii}
                            />
                            <Route
                                path={
                                    routes.LOCAL_AUTHORITY_PATTERN + routes.PROJECTION_COUNTERS
                                }
                                component={Projection}
                            />
                            <Route
                                path={routes.LOCAL_AUTHORITY_PATTERN}
                                component={Router.LocalAuthorityRouter}
                            />
                            <Route
                                path={routes.GLOSSAIRE}
                                component={GlossaryComponent}
                            />
                            <Route
                                path={routes.INFORMATION_REGLEMENTAIRE}
                                component={RegulatoryInformationComponent}
                            />
                        </Switch>
                    </Content>
                )}
            </div>
        );
    }

    private _handleRefresh = () => {
        const id = this.props.currentLocalAuthority ? this.props.currentLocalAuthority.id.toString() : ''
        localStorage.setItem(KEY_CURRENT_LOCAL_AUTHORITY, this.props.currentLocalAuthority.id.toString());
    }
}


export interface SecuredComponentProps {
    currentLocalAuthority: Model.LocalAuthority;
    currentLocalAuthorityLoans: Model.Loan[];
    currentUser: Model.User;
    loadingCurrentLocalAuthority: boolean;
    loadingCurrentUser: boolean;
    loadingLocalAuthorities: boolean;
    loans: Model.Loan[];
    localAuthorities: Model.LocalAuthority[];
    menuOpen: boolean;
    title: string;
    loaderStoreData: any;

    onLogout(): void;

    onLocalAuthorityChange(id: number): void;

    onMenuButtonClick(): void;

    onMenuItemClick(): void;

    setLoaderValue(data: any): void;

    fetchedTableDataValue(fetchedTableData: any): void;

    totalCalls: number;
    ongoingCalls: number;
    allCallFinished: boolean;
    setTotalCalls(totalCalls: number): void;
    resetOngoingCalls(): void;
    incrementCall(): void;
    finishCall(): void;
    allCallsFinished(data: boolean): void;

}



// WEBPACK FOOTER //
// ./src/route/secured/secured-component.tsx